import { render, staticRenderFns } from "./offCompanies.vue?vue&type=template&id=4dafb33b"
import script from "./offCompanies.vue?vue&type=script&lang=js"
export * from "./offCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports